import { Component, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { VehicleCategorySearchDto } from '@splitsecondconnect/ultramarine-shared';

import { ultraAnimations } from '../../../../../shared/animations';
import { BaseSectionComponent } from '../../../../../shared/base-classes/sections/base-section.component';
import { SectionWrapperComponent } from '../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { SearchableFieldComponent } from '../../../../../shared/components/searchable-field/searchable-field.component';
import { BaseModel } from '../../../../../shared/models/base.model';
import { SelectItem } from '../../../../../shared/models/select-item.type';
import { SEARCHABLE_STRATEGY_TOKEN } from '../../../../../shared/tokens/searchable-strategy.token';
import { VehicleCategorySearchStrategy } from '../../config/vehicle-category-searchable-strategy';

class HostModuleModel extends BaseModel {
	vehicleCategoryId: number;
}

@Component({
	selector: 'app-vehicle-category-section',
	templateUrl: 'vehicle-category-section.component.html',
	imports: [
		SectionWrapperComponent,
		ReactiveFormsModule,
		SearchableFieldComponent,
	],
	animations: ultraAnimations,
	providers: [
		{
			provide: SEARCHABLE_STRATEGY_TOKEN,
			useClass: VehicleCategorySearchStrategy,
		},
	],
})
export class VehicleCategorySectionComponent extends BaseSectionComponent<HostModuleModel> {
	protected _skipCount: number = 0;
	selectedItem = signal<SelectItem<VehicleCategorySearchDto>>(null);
	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			vehicleCategoryId: [null],
		});
	}

	_mapModelToForm(): void {
		const detailsFormData: any = {
			vehicleCategoryId: this.recordData().vehicleCategoryId,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	_mapFormToModel(): Partial<HostModuleModel> {
		return {
			vehicleCategoryId: this.detailsForm.value.vehicleCategoryId,
		};
	}
}
